import React, { useMemo } from "react";
import BaseButton from "../../components/button/BaseButton";
import "../../assets/scss/_payment.scss";
// import AdliyaLogo from "../../assets/images/Adliya.png";
// import WorldPayLogo from "../../assets/images/WorldPay.png";
// import QRCode from "react-qr-code";
import QRCode from "qrcode.react";
import { useNavigate } from "react-router-dom";

const PaymentConfirmCheck = ({ item, duplicateText }) => {
  const navigate = useNavigate();
  const qr = useMemo(() => item, [item]);

  return (
    <div className="payment-confirm-check">
      <div className="left">
        {/* {item?.vendor_id?.logo && <img src={item?.vendor_id?.logo} alt="" />} */}
        {/* <img src={AdliyaLogo} className="h-[70px] !mb-4" alt="" /> */}
        <QRCode
          id={`https://dunyopay.uz/d/r/${qr?.id}`}
          value={`https://dunyopay.uz/d/r/${qr?.id}`}
          renderAs="canvas"
          size={120}
        />
        <div className="text-[8px] text-[#5b5b5b] mt-2">
          Кассир: {item?.user_id?.data?.login}
        </div>
        <div className="text-[8px] uppercase text-[#5b5b5b] mt-2">
          "CS EXPRESS PAY" AJ
        </div>
        {/* <img src={WorldPayLogo} className="!mt-4" alt="" /> */}
        <BaseButton
          name={item?.status?.int == 2 ? "Оплачено" : item?.status?.string}
          className={`button-success !border-[3px] ${
            item?.status?.int === 2
              ? "!border-[#2e8b57] !text-[#2e8b57]"
              : "!border-[#3e3e3e] !text-[#3e3e3e]"
          } !text-xl !border-dashed !h-[45px] md:absolute left-[150%] md:rotate-[-45deg] !w-[200px] font-600 !bg-transparent`}
          style={{ fontSize: "12px" }}
        />
        {duplicateText && (
          <BaseButton
            name={"ДУБЛИКАТ"}
            className={`button-success !border-[3px] !border-[#C10000] !text-[#C10000] !text-xl !border-dashed !h-[45px] md:absolute left-[300%] md:rotate-[-45deg] !w-[200px] font-600 !bg-transparent`}
            style={{ fontSize: "12px" }}
          />
        )}
      </div>
      <div className="center">
        <div className="md:w-[80%] md:min-w-[80%] py-2">
          <div className="item">
            <div className="item-left">Ташкилот</div>
            <div className="item-right">"WORLD PAY" MCHJ</div>
          </div>
          <div className="item">
            <div className="item-left">Банк муассасаси</div>
            <div className="item-right">"CS EXPRESS PAY" AJ</div>
          </div>
          <div className="item">
            <div className="item-left">Инвойс</div>
            <div className="item-right">{item?.account}</div>
          </div>
          <div className="item">
            <div className="item-left">Лицевой счет</div>
            <div className="item-right">
              {item?.cheque_details?.budget_income}
            </div>
          </div>
          <div className="item">
            <div className="item-left">Номер транзакции в системе</div>
            <div className="item-right">{item?.id}</div>
          </div>
          <div className="item">
            <div className="item-left">Номер транзакции банка</div>
            <div className="item-right">{item?.partner_transaction_id}</div>
          </div>
          {item?.cheque_details?.mfo_receiver && (
            <div className="item">
              <div className="item-left">Код банка</div>
              <div className="item-right">
                МФО: {item?.cheque_details?.mfo_receiver}
              </div>
            </div>
          )}
          {item?.cheque_details?.bank_transaction_id && (
            <div className="item">
              <div className="item-left">Номер транзакции Мунис</div>
              <div className="item-right">
                {item?.cheque_details?.bank_transaction_id}
              </div>
            </div>
          )}
          {item?.cheque_details?.name_receiver && (
            <div className="item">
              <div className="item-left">Получатель платежа</div>
              <div className="item-right">
                {item?.cheque_details?.name_receiver}
              </div>
            </div>
          )}
          <div className="item">
            <div className="item-left">Начислено:</div>
            <div className="item-right" style={{ color: "#2e8b57" }}>
              {Number(item?.amount)?.toLocaleString("ru-RU")}{" "}
              {item?.currency?.string}
            </div>
          </div>
          <div className="item">
            <div className="item-left">Комиссия:</div>
            <div className="item-right">
              {Number(item?.commission_amount)?.toLocaleString("ru-RU")}{" "}
              {item?.currency?.string}
            </div>
          </div>
          <div className="item">
            <div className="item-left">Услуга:</div>
            <div className="item-right">
              {item?.vendor_id?.data?.short_name}
            </div>
          </div>
          <div className="item">
            <div className="item-left">Плательщик ФИО:</div>
            <div className="item-right">{item?.payer_full_name}</div>
          </div>
          <div className="item">
            <div className="item-left">Отделение:</div>
            <div className="item-right">{item?.structure_id?.data?.name}</div>
          </div>
        </div>
        <div className="right flex flex-col items-center justify-center">
          {qr?.fiscal_details?.qrCodeUrl ? (
            <a href={qr?.fiscal_details?.qrCodeUrl} target="_blank">
              <QRCode
                id={qr?.fiscal_details?.qrCodeUrl}
                value={qr?.fiscal_details?.qrCodeUrl}
                renderAs="canvas"
              />
            </a>
          ) : (
            <div>OFD chek sms orqali yuboriladi</div>
          )}
          {item?.fiscal_details?.receiptId && (
            <div className="text-[8px] uppercase text-[#5b5b5b] mt-2 self-start">
              Ракам: {item?.fiscal_details?.receiptId}
            </div>
          )}
          {item?.fiscal_details?.terminalId && (
            <div className="text-[8px] uppercase text-[#5b5b5b] self-start">
              Терминал: {item?.fiscal_details?.terminalId}
            </div>
          )}
          {item?.fiscal_details?.fiscalSign && (
            <div className="text-[8px] uppercase text-[#5b5b5b] self-start">
              ФИСК Б: {item?.fiscal_details?.fiscalSign}
            </div>
          )}
        </div>
        <div className="center-footer">
          {/* <div>
            <div className="footer-label">Тип оплаты</div>
            <div className="footer-label">
              {item?.cheque_details?.budget_income_name
                ? item?.cheque_details?.budget_income_name
                : "."}
            </div>
          </div> */}
          <div>
            <div className="footer-label">Дата/время</div>
            <div className="footer-label">{item?.created_at?.date}</div>
          </div>
          <div>
            <div className="footer-label">Обшая сумма</div>
            <div className="footer-label">
              {Number(item?.amount)?.toLocaleString("ru-RU")}{" "}
              {item?.currency?.string}
            </div>
          </div>
          <div>
            <div className="footer-label">Подпись</div>
            <div className="footer-label">.</div>
          </div>
          <div>
            <div className="footer-label">.</div>
            <div className="footer-label">.</div>
          </div>
        </div>
        <div className="border-b border-[#a9a4a4] text-center w-full text-[12px] px-[8px] py-[4px]">
          Тип оплаты: {item?.cheque_details?.budget_income_name}
        </div>
        <div className="border-b border-[#a9a4a4] text-center w-full text-[12px] px-[8px] py-[4px]">
          Сумма: {Number(item?.amount)?.toLocaleString("ru-RU")} UZS
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmCheck;
